import i18n, { InitOptions } from 'i18next';
import React, { FC, createContext } from 'react';
import { initReactI18next } from 'react-i18next';

type Props = InitOptions;

const InternationalizationProvider: FC<Props> = ({ children, ...otherProps }) => {
    const InternationalizationContext = createContext('__internationalizationContext');

    i18n.use(initReactI18next) // passes i18n down to react-i18next
        .init({
            keySeparator: false, // we do not use keys in form messages.welcome
            fallbackLng: 'en',
            defaultNS: 'common',
            interpolation: {
                escapeValue: false, // react already safes from xss
            },
            ...otherProps,
        });

    return <InternationalizationContext.Provider value="">{children}</InternationalizationContext.Provider>;
};

export default InternationalizationProvider;
